<template>

  <div class="corretiva-parametro ml-4 mr-4" >
      <b-form>          
          <b-row>
              <!-- -->


              <b-col cols="1">
                <br>
                <b-button variant="warning" class="ml-5 mt-2" v-b-modal.modal-multi-parametro @click="reset(),loadGrupo()">Novo</b-button>
              </b-col>

          </b-row>
    </b-form>

    
    <div class="d-flex justify-content-center mb-3">      
    </div>    
    <!--tbl de dados -->
    <b-table id="parametro"  small hover striped sticky-header="550px"  :items="parametros" :fields="fields" >    
        <template slot="cell(actions)" slot-scope="data"  >
          <b-button  @click="editparametro(data.item), loadGrupo()"    title="Editar parâmetro"  size="sm" variant="primary" class="mr-2 mt-2" v-b-modal.modal-multi-parametro>                
            <i class="fa fa-exclamation-circle"></i>              
          </b-button> 
        </template>  

        <template v-slot:cell(status)="data">
          {{ data.item.status ? 'ATIVO' : 'INATIVO' }}
        </template>

    </b-table>

      <!--  MODAL GRAVAÇÃO RELACAO DA parametro CORRETIVA -->
      <!--  MODAL GRAVAÇÃO RELACAO DA parametro CORRETIVA -->
      <div>        
    <b-modal id="modal-multi-parametro"   hide-footer size="lg" title="Cadastro de parametros">
          <!-- -->
          <div>
            <b-row>
              <b-col cols="5">
                <label for="input-grupo">DEPARTAMENTO</label>  
                <div>                
                  <b-form-select                  
                    v-model="parametro.id_area"                                                     
                    :options="departamentos"
                    class="mb-3 "
                    text-field="area"
                    >                
                  </b-form-select>
                </div>
              </b-col>  

              
              <b-col cols="3"  class="mb-0">
                <label  for="input-busca">Duração </label> 
                <b-form-input id="parametro-duracao" v-model="parametro.atendimento_intervalo"  type="number" required="required" placeholder="Intervalo"></b-form-input>              
              </b-col>   

              <b-col cols="4">                                              
                  <b-form-checkbox
                    id="cobrador" 
                    class="mb-3 mt-5"                                    
                    name="cobrador"
                    value="true"
                    v-model="parametro.status"
                    unchecked-value="false"
                    checked="true"
                  >                  
                  Permitir agendamento <!-- --{{rfilancamento.lavador}} -->
                  </b-form-checkbox>                
               </b-col>



            </b-row>


            <b-row>
              <b-col cols="3">
                <label for="servico-inicio">Inicio atendimento</label> 
                  <div>                
                    <b-form-input id="ini-servico" v-model="parametro.atendimento_hr_inicio" type="time"></b-form-input>
                  </div>
              </b-col>              
              
              <b-col cols="3">
                <label for="servico-inicio">Término atendimento</label> 
                  <div>                
                    <b-form-input id="ini-servico" v-model="parametro.atendimento_hr_termino" type="time"></b-form-input>
                  </div>
              </b-col>

              <b-col cols="3">
                <label for="servico-inicio">Inicio refeição</label> 
                  <div>                
                    <b-form-input id="ini-servico" v-model="parametro.refeicao_hr_inicio" type="time"></b-form-input>
                  </div>
              </b-col>              
              
              <b-col cols="3">
                <label for="servico-inicio">Término refeição</label> 
                  <div>                
                    <b-form-input id="ini-servico" v-model="parametro.refeicao_hr_termino" type="time"></b-form-input>
                  </div>
              </b-col>




          </b-row>  
          <input  id="id-parametro" type="hidden" v-model="parametro.id" />
         
             <b-button class="mt-3" variant="success" block @click="postparametro()">Gravar</b-button>            
          </div>          
        </b-modal>
      </div>
      <!--  MODAL GRAVAÇÃO RELACAO DA parametro INDISPONIVEL -->
  </div>  
</template>


<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
//import Multiselect from 'vue-multiselect'
import moment from 'moment'
import { mapState } from 'vuex' 





export default {    
    name: 'Manutencaoparametro',   
    computed : { ... mapState (['user'],),} , 

    data: function() {

        
      
        return {                        
            carregando: false,            
            parametros:[],                    
            parametro:{},            
            value_grupo: '',                     
            
          //  barra_inicial: 0,         
          //  barra_limite: 300000,
            
            fields: [
                { key: 'id', label: 'Id', sortable: true },     
                { key: 'empresa_id', label: 'Empresa', sortable: true },   
                { key: 'departamento', label: 'Departamento', sortable: true },     
               
                { key: 'atendimento_hr_inicio',label: 'Início atendimento',sortable: true, formatter: (value) => {                        
                        return moment(value, 'HH:mm:ss', true).isValid() ? moment(value, 'HH:mm:ss').format('HH:mm') : '-';
                    }
                },

                { key: 'atendimento_hr_termino',label: 'Término atendimento',sortable: true, formatter: (value) => {                        
                        return moment(value, 'HH:mm:ss', true).isValid() ? moment(value, 'HH:mm:ss').format('HH:mm') : '-';
                    }
                },

                { key: 'atendimento_hr_termino', label: 'Término atendimento', sortable: true, formatter: (value, key, parametros) => {
                    return moment(parametros.atendimento_hr_termino).format('HH:mm').replace('Horário inválido','-') ; }  },

                { key: 'atendimento_intervalo', label: 'Intervalo entre antendimento', sortable: true },    
                { key: 'status', label: 'Status', sortable: true },    
                
                //////////// intervalo parada para refeição
                                { key: 'refeicao_hr_inicio',label: 'Início refeição',sortable: true, formatter: (value) => {                        
                        return moment(value, 'HH:mm:ss', true).isValid() ? moment(value, 'HH:mm:ss').format('HH:mm') : '-';
                    }
                },
                
                { key: 'refeicao_hr_termino',label: 'Término refeição',sortable: true, formatter: (value) => {                        
                        return moment(value, 'HH:mm:ss', true).isValid() ? moment(value, 'HH:mm:ss').format('HH:mm') : '-';
                    }
                },


                { key: 'dt_cadastro', label: 'Data Cadastro', sortable: true, formatter: (value, key, parametros) => {
                    return moment(parametros.dt_cadastro).format('DD/MM/YYYY - HH:mm').replace('Data inválida','-') ; }  },

                { key: 'dt_alteracao', label: 'Data Alteração', sortable: true, formatter: (value, key, parametros) => {
                    return moment(parametros.dt_alteracao).format('DD/MM/YYYY - HH:mm').replace('Data inválida','-') ; }  },

                { key: 'actions', label: 'Ações' },
                
            ]
        }        
    },

    components: {
        
    },
    methods: {

        loadGrupo() {      
            let params = {    
                "empresa_id": `${this.user.id_empresa}`,   
                "agendamento": true,
                "origem": 'agendamento'    ,
                                "psg": `${this.user.psg}`,                                            
                "orc": `${this.user.orc}`,                                          
            };    
          const url = `${baseApiUrl}/informatica/sac/departamento`   
          axios.get(url,{params})
               .then(res => {this.departamentos = res.data.map(gru => {return { ... gru, value: gru.id_area, area: gru.area} })})
               .catch(showError)
          
        },  



        loadAgendamentoParametro() {   
          let corpo = {    
                "empresa_id": `${this.user.id_empresa}`,                                            
                "psg": `${this.user.psg}`,                                            
                "orc": `${this.user.orc}`,                                                      };          
          const url = `${baseApiUrl}/sac/agendamento/parametro`
          axios.post(url,corpo).then(res => {
            this.carregando = false;       
            this.parametros = res.data.map(parametro => {              
              return { ... parametro}
            })
          })
        },  

        editparametro(parametro){
            this.parametro = { ...parametro }
        },

          
postparametro() {                        
    let corpo = {                 
          "empresa_id": `${this.user.id_empresa}`,     
          "funcionario_id": `${this.user.id_funcionario}`, 
          "id": `${this.parametro.id}`,                         
          "depto_id": `${this.parametro.id_area}`,     
          "atendimento_hr_inicio": `${this.parametro.atendimento_hr_inicio}`,  
          "atendimento_hr_termino": `${this.parametro.atendimento_hr_termino}`,  
          "atendimento_intervalo": `${this.parametro.atendimento_intervalo}`,  
          "refeicao_hr_inicio": `${this.parametro.refeicao_hr_inicio}`,  
          "refeicao_hr_termino": `${this.parametro.refeicao_hr_termino}`, 
          "psg": `${this.user.psg}`,                                  
          "status": `${this.parametro.status}`
    };

    const url = `${baseApiUrl}/sac/agendamento/parametrocad`;

    axios.post(url, corpo)
        .then(response => {
            // Verifique se o status é 201
            if (response.status === 201) {
                // Se a resposta contiver uma mensagem, exiba-a
                if (response.data && response.data.mensagem) {
                    this.$toasted.global.defaultSuccess(response.data.mensagem);
                } else {
                     this.$toasted.global.defaultSuccess();
                }
                this.reset(); // Limpar os objetos e valores
            }
        })
        .catch(showError);
},


        reset() {  
            this.parametro = {}          
            this.parametro = []
            this.loadAgendamentoParametro()            
        }
       
    },



    mounted() {        
      this.loadAgendamentoParametro()
      this.loadGrupo()
    },



}

</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

#selecaostatusx{
    font-size: 0.7em;      
}

#departamentos{   
    font-size: 0.9em;      
    text-align: center;
    
}




</style>